import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

export default {
  update: (params) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/saveParamsClient',
      method: 'post',
      body: params
    })
  }
}
